<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">Vincular unidades ao usuário</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="custom-font">Selecione o usuário</label>
            <div class="custom-select">
              <v-select
                v-model="filters.sshd"
                label="nome"
                :reduce="u => u.username"
                :placeholder="
                  users.length === 0
                    ? 'CARREGANDO A LISTA DE USUÁRIOS...'
                    : 'PESQUISE O NOME DO USUÁRIO AQUI...'
                "
                :options="users"
                :selectOnTab="true"
                @input="refreshLists"
              >
              </v-select>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-sm-6">
          <list
            ref="listUnidadesVinculadas"
            :show-empty="true"
            :show-print-button="false"
            :show-column-visibility-button="false"
            :load-on-start="false"
            api-url="escala/listar-unidade-vinculadas-sshd"
            title="Unidades vinculadas"
            :fields="columns"
            :appendParams="filters"
            :initial-page="paginaUnidadesVinculadas"
            :pageCollection="'escalasVincularUnidadeUsuario'"
          >
            >
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Desassociar"
                  class="btn btn-danger"
                  @click="desvincular(props.rowData)"
                >
                  <font-awesome-icon :icon="'minus'" />
                </button>
              </div>
            </template>
          </list>
        </div>

        <div class="col-xs-12 col-sm-6">
          <list
            ref="listUnidadesDisponiveis"
            :show-empty="true"
            :load-on-start="false"
            :show-print-button="false"
            :show-column-visibility-button="false"
            api-url="escala/listar-unidade-disponiveis-sshd"
            title="Unidades disponíveis para vínculo"
            :fields="columns"
            :appendParams="filters"
            :initial-page="paginaUnidadesDisponiveis"
            :pageCollection="'escalasVincularUnidadeUsuario'"
          >
            <template slot="filters">
              <div class="" id="associar-filtros">
                <div class="col-xs-12">
                  <input
                    type="search"
                    class="form-control"
                    placeholder="Filtre aqui a unidade"
                    v-model="filters.filter"
                    @keyup="pesquisarUnidades"
                  />
                </div>
              </div>
            </template>
            <template slot="rowrender" slot-scope="props">
              <div class="">
                <button
                  title="Associar"
                  type="button"
                  class="btn btn-success"
                  @click="vincular(props.rowData)"
                >
                  <font-awesome-icon :icon="'plus'" />
                </button>
              </div>
            </template>
          </list>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.custom-font {
  font-size: 16px;
  color: #00615c;
}

.custom-select {
  border: 1px solid;
  border-radius: 4px;
  border-color: #00615c;
}
</style>

<script>
import list from '@/components/common/DataTable'
import { request } from '@/request'

export default {
  name: 'vincular-unidades-usuario',
  data() {
    return {
      users: [],
      filters: {
        sshd: '',
        filter: ''
      },
      lastFilter: '*',
      columns: [
        {
          name: 'sigla',
          title: 'Nome',
          dataClass: 'align-middle',
          filterable: true
        },
        {
          name: '__slot:actions',
          title: 'Ações',
          titleClass: 'text-center col-md-3',
          dataClass: 'text-center'
        }
      ]
    }
  },
  components: {
    list
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadUsers()
  },
  computed: {
    associadoFiltros() {
      return {
        userid: this.userActive,
        nome: this.associadoNome
      }
    },
    associarFiltros() {
      return {
        userid: this.userActive,
        nome: this.associarNome
      }
    },
    paginaUnidadesVinculadas: {
      get() {
        const { escalasVincularUnidadeUsuario } = this.$store.state.vuetableState
        const { paginaUnidadesVinculadas } = escalasVincularUnidadeUsuario
        return paginaUnidadesVinculadas
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'escalasVincularUnidadeUsuario',
          value: value
        })
      }
    },
    paginaUnidadesDisponiveis: {
      get() {
        const { escalasVincularUnidadeUsuario } = this.$store.state.vuetableState
        const { paginaUnidadesDisponiveis } = escalasVincularUnidadeUsuario
        return paginaUnidadesDisponiveis
      },
      set(value) {
        this.$store.commit('SET_FILTER_PAGE', {
          collection: 'escalasVincularUnidadeUsuario',
          value: value
        })
      }
    }
  },
  methods: {
    loadUsers() {
      request
        .get('user/list/all')
        .then(response => {
          const { data } = response
          this.users = data
        })
        .catch(e => {
          console.log(e)
        })
    },
    pesquisarUnidades() {
      const { filter } = this.filters
      if (
        (filter.length === 0 || filter.length > 3) &&
        filter !== this.lastFilter
      ) {
        this.$refs.listUnidadesDisponiveis.refresh()
        this.lastFilter = filter
      }
    },
    vincular(unidade) {
      request
        .post('escala/vincular-unidade', { sshd: this.filters.sshd, unidade })
        .then(response => {
          this.refreshLists()
        })
        .catch(e => {
          this.$toastr.e(
            `Ops falha ao tentar vincular a unidade ${unidade.sigla} , Tente novamente daqui alguns minutos!`
          )
          console.log(e)
        })
    },
    desvincular(unidade) {
      request
        .post('escala/desvincular-unidade', {
          sshd: this.filters.sshd,
          unidade
        })
        .then(response => {
          this.refreshLists()
        })
        .catch(e => {
          this.$toastr.e(
            `Ops falha ao tentar desvincular a unidade ${unidade.sigla} , Tente novamente daqui alguns minutos!`
          )
          console.log(e)
        })
    },
    refreshLists() {    
      this.$nextTick(function () {
        this.$refs.listUnidadesVinculadas.refresh()
        this.$refs.listUnidadesDisponiveis.refresh()
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/admin/escalas/VincularUnidadesUsuario.vue